import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ReleaseAnnouncement from "@/components/ReleaseAnnouncement";

export default function Layout() {
  return (
    <div className="relative min-h-screen bg-transparent">
      {/* Warm festival ambient background across the whole site */}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-0"
        style={{
          backgroundImage: "url(/generated/festival_bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(70px) saturate(1.1)",
          opacity: 0.34,
          mixBlendMode: "screen",
        }}
      />
      <Header />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
      <ReleaseAnnouncement />
    </div>
  );
}
